/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */

import {
  GET_ASSET_CONTACTS_SUCCESS,
  GET_ASSET_CONTACTS_FAILURE,
  ADD_ASSET_CONTACT_SUCCESS,
  ADD_ASSET_CONTACT_FAILURE,
  UPDATE_ASSET_CONTACT_SUCCESS,
  UPDATE_ASSET_CONTACT_FAILURE,
  DELETE_ASSET_CONTACT_SUCCESS,
  DELETE_ASSET_CONTACT_FAILURE,
  GET_ALL_CONTACTS_SUCCESS,
  GET_CONTACT_ASSETS_SUCCESS,
  GET_CONTACT_SUCCESS,
  CLEAR_CONTACTS,
  CLEAR_PARTNER_ASSETS,
  PARSE_BULK_ADD_CONTACTS,
  PARSE_BULK_ADD_CONTACTS_SUCCESS,
  PARSE_BULK_ADD_CONTACTS_FAILURE,
  PARSE_BULK_ADD_CONTACTS_ASSETS,
  PARSE_BULK_ADD_CONTACTS_ASSETS_SUCCESS,
  PARSE_BULK_ADD_CONTACTS_ASSETS_FAILURE,
  CLEANUP_CONTACT,
} from "../actions/actionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse,
} from "./reducerUtils";
import { BULK_ADD_CLIENT_SUCCESS } from "../actions/asset/assetActionTypes";

const initialState = {
  contacts: null,
  contactAssets: null,
  contactDetails: null,
  parseBulkAddContacts: {
    data: null,
    state: "INIT",
    error: null,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ASSET_CONTACTS_SUCCESS:
      return {
        loadingContactsSuccess: true,
        contacts: action.payload.contacts,
      };

    case GET_ASSET_CONTACTS_FAILURE:
      return {
        loadingContactsSuccess: false,
        error: action.err.message,
        contacts: state.contacts,
      };

    case ADD_ASSET_CONTACT_SUCCESS:
      return {
        addingSuccess: true,
        contacts: action.payload.contacts,
      };

    case ADD_ASSET_CONTACT_FAILURE:
      return {
        addingSuccess: false,
        error: action.err.message,
        contacts: state.contacts,
      };

    case UPDATE_ASSET_CONTACT_SUCCESS:
      return {
        updatingSuccess: true,
        contacts: action.payload.contacts,
      };

    case UPDATE_ASSET_CONTACT_FAILURE:
      return {
        updatingSuccess: false,
        error: action.err.message,
        contacts: state.contacts,
      };

    case DELETE_ASSET_CONTACT_SUCCESS:
      return {
        deletingSuccess: true,
        contacts: action.payload.contacts,
      };

    case DELETE_ASSET_CONTACT_FAILURE:
      return {
        deletingSuccess: false,
        error: action.err.message,
        contacts: state.contacts,
      };

    case CLEAR_CONTACTS:
      return {
        ...state,
        contacts: {
          ...state.contacts,
          contacts: null,
        },
      };

    case GET_ALL_CONTACTS_SUCCESS:
      return {
        ...state,
        contacts: action.payload,
      };

    case GET_CONTACT_ASSETS_SUCCESS:
      return {
        ...state,
        contactAssets: action.payload,
      };
    case CLEAR_PARTNER_ASSETS:
      return {
        ...state,
        contactAssets: {
          ...state.contactAssets,
          assets: null,
        },
      };
    case GET_CONTACT_SUCCESS:
      return {
        ...state,
        contactDetails: action.payload,
      };

    case CLEANUP_CONTACT:
      return {
        ...state,
        contactDetails: null,
      };

    case PARSE_BULK_ADD_CONTACTS:
      return setLoadingState(state, "parseBulkAddContacts");

    case PARSE_BULK_ADD_CONTACTS_SUCCESS:
      return setSuccessResponse(state, action, "parseBulkAddContacts");

    case PARSE_BULK_ADD_CONTACTS_FAILURE:
      return setErrorResponse(state, action.err, "parseBulkAddContacts");

    case PARSE_BULK_ADD_CONTACTS_ASSETS:
      return setLoadingState(state, "parseBulkAddContacts");

    case PARSE_BULK_ADD_CONTACTS_ASSETS_SUCCESS:
      return setSuccessResponse(state, action, "parseBulkAddContacts");

    case PARSE_BULK_ADD_CONTACTS_ASSETS_FAILURE:
      return setErrorResponse(state, action.err, "parseBulkAddContacts");

    case BULK_ADD_CLIENT_SUCCESS:
      return {
        ...state,
        parseBulkAddContacts: {
          data: null,
          state: "INIT",
          error: null,
        },
      };

    default:
      return state;
  }
}
